import { useRecurly } from '@recurly/react-recurly'
import { RecurlyError } from '@recurly/recurly-js/lib/error'
import { useCallback, useState } from 'react'
import { SubscriptionPricingState } from '@pff-consumer/utils/lib/accounts/subscribe/recurly/subscription-pricing'

// The new hook for pricing
export const usePricing = (coupon: string, subscription: string, handleError?: (error: RecurlyError) => any) => {
  const recurly = useRecurly()
  const checkoutPricing = recurly.Pricing.Subscription()
  const [price, setPrice] = useState<SubscriptionPricingState>()
  const [loading, setLoading] = useState<boolean>(false)

  const fetchPrice = useCallback(
    (sub: string, cp: string) => {
      setLoading(true)
      checkoutPricing
        .plan(sub, { quantity: 1 })
        .coupon(cp)
        .catch((e) => {
          if (handleError) {
            setLoading(false)
            handleError(e)
          }
        })
        .done(
          (data) => {
            // react-recurly doesn't type this response correctly so we are forced to cast the type here
            setPrice(data as unknown as SubscriptionPricingState)
            setLoading(false)
          },
          (error) => {
            if (handleError) {
              setLoading(false)
              handleError(error)
            }
          }
        )
    },
    [checkoutPricing, handleError]
  )

  const updatePrice = (sub: string, cp: string) => {
    fetchPrice(sub, cp)
  }

  return {
    price,
    updatePrice,
    loading,
  }
}
